import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Switch, CircularProgress } from '@mui/material'
import { usePermissions } from '../../../../core/hooks'
import { toggleUserActive } from '../../slices'
import { withStyles } from '@mui/styles'

const switchStyles = (theme) => ({
  root: {
    marginRight: 10,
  },
  switchBase: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  track: {
    backgroundColor: theme.palette.grey[500],
  },
  checked: {},
})

export const TableActions = withStyles(switchStyles)(({ classes, row, ...props }) => {
  const dispatch = useDispatch()
  const users = useSelector((state) => state.users.data)
  const global = useSelector((state) => state.global)
  const { isPrescriptor } = usePermissions()

  const userData = row?.original || {}
  const switchDisabled = !isPrescriptor || '' + userData.id === global.user_id
  const userState = userData.activo
  const [isLoading, setIsLoading] = useState(false)

  const handleToggleState = (e) => {
    e.stopPropagation()
    if (userData && userData.id !== undefined) {
      dispatch(toggleUserActive({ original: userData }, users, setIsLoading))
    }
  }

  if (!userData || userData.id === undefined) {
    return null
  }

  return isLoading ? (
    <CircularProgress size={20} style={{ display: 'inline-block', verticalAlign: 'middle' }} />
  ) : (
    <Switch
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        track: classes.track,
        checked: classes.checked,
      }}
      checked={userState}
      onClick={handleToggleState}
      disabled={switchDisabled}
    />
  )
})
